<template>
  <div>
    <div class="header-gnb">
      <h1 class="logo">
        <a @click="changeUrl({path: '/index.html', name: 'home'})">
          <img src="../../../assets/images/common/ci-wavve.png" alt="wavve" />
        </a>
      </h1>
      <ul class="gnb-left">
        <li>
          <a href="#" :class="isActive(['home'])" @click.prevent="changeUrl({path: '/index.html', name: 'home'})">홈</a>>
        </li>
        <li class="category-list-item" @focusin="focus()" @mouseenter="focus()" @mouseleave="blur()" ref="gnbCategory"
            :key="'CATEGORY_INDEX_KEY_' + categoryKeyIndex">
          <span tabindex="0" data-gnb="category-menu">카테고리</span>
          <category-menu></category-menu>
          <category-menu-layer></category-menu-layer>
        </li>
        <li>
          <a href="#" :class="isActive(['live'])" @click.prevent="changeUrl({path: '/live/index.html', name: 'live'})">LIVE</a>
        </li>
        <li>
          <a href="#" :class="isActive(['my'])" @click.prevent="changeUrl({path: '/my', name: 'my'})">MY</a>
        </li>
      </ul>
      <ul class="gnb-right">
        <li>
          <button @click.prevent="showSearchPopup('popul')" class="btn-search">
            <span>검색하기</span>
          </button>
        </li>
      </ul>
    </div>

    <!-- 검색 팝업 -->
    <search-popup v-if="showSearchPop" id="searchPop" :closeSearchPopup="closeSearchPopup" :pageType="searchPageType" />
  </div>
</template>

<script>
import _ from 'lodash'
import SearchPopup from '@/components/search/SearchPopup'
import { setDisableScrolling } from '@/common/utils/common'
import { UPDATE_MAIN_LAYOUT_CONTENT, SET_CURRENT_MENU } from '@/common/resources/const'
import { mapMutations, mapGetters } from 'vuex'
import CategoryMenu from '@/components/common/header/CategoryMenu'
import CategoryMenuLayer from '@/components/common/header/CategoryMenuLayer'
import {
  categoryInfo,
  EVENT_UPDATE_CATEGORY_COMPONENT
} from '@/common/utils/gnb.category'
export default {
  components: { CategoryMenuLayer, CategoryMenu, SearchPopup },
  data () {
    return {
      showSearchPop: false,
      searchPageType: 'popul',
      section: '',
      categoryKeyIndex: 0
    }
  },
  computed: {
    ...mapGetters(['currentMenu'])
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    changeUrl (gnbInfo) {
      const { path, name } = gnbInfo
      if (this.$route.name === name) {
        this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
      } else {
        this.$router.push(path)
      }
    },
    isActive (type) {
      return type.indexOf(this.currentMenu) > -1 ? 'on' : ''
    },
    setSection () {
      const section = _.get(this.$route, ['meta', 'section'], '')
      if (section) {
        this.section = section
      }
    },
    showSearchPopup (type) {
      if (typeof window.setInputShow === 'function') {
        window.setInputShow(false)
      }
      this.searchPageType = type
      this.showSearchPop = true
      setDisableScrolling(true) // 윈도우 스크롤 방지
      // if (window.playerInstance) window.playerInstance.removeKeyEvent() // 플레이어 키 이벤트 비활성화
      if (window.playerInstance) window.playerInstance.clearEvent() // 플레이어 키 이벤트 비활성화
    },
    closeSearchPopup () {
      this.showSearchPop = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
      if (window.playerInstance) window.playerInstance.setupEvent() // 플레이어 키 이벤트 활성화
    },
    categoryComponentUpdate () {
      categoryInfo.clearCache()
      this.categoryKeyIndex += 1
    },
    focus () {
      this.$refs.gnbCategory.classList.add('on')
    },
    blur () {
      this.$refs.gnbCategory.classList.remove('on')
    },
    keyup (e) {
      if (e.target.dataset.gnb !== 'category-menu') this.blur()
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
  },
  created () {
    this.$events.$on('showSearchPopupTag', value => {
      this.showSearchPopup(value)
    })
    this.$events.$on(EVENT_UPDATE_CATEGORY_COMPONENT, this.categoryComponentUpdate)
    window.showTagSearchLayout = (type) => {
      let tempType = type
      if (type === 'movie') tempType = 'reTagDetail_movie'
      this.showSearchPopup(tempType)
    }
  },
  beforeDestroy () {
    delete window.showTagSearchLayout
    this.$events.$off('showSearchPopup')
    this.$events.$off('setInputShow')
    this.$events.$off(EVENT_UPDATE_CATEGORY_COMPONENT)
    document.removeEventListener('keyup', this.keyup)
  },
  watch: {
    $route () {
      this.setSection()
    }
  }
}
</script>
